'use client'

import { Button } from '~/components/ui/button'
import Container from '~/components/ui/container'
import { Link } from '~/components/ui/link'
import { Twemoji } from '~/components/ui/twemoji'
import { Icon404 } from '~/icons/ic_404'
import { useLocale } from '~/contexts/LocaleContext'
import { getTranslation } from '~/lib/i18n-utils'

export default function NotFound() {
  const { locale } = useLocale()
  const t = getTranslation(locale)

  return (
    <Container className="pt-4 lg:pt-12">
      <div className="flex flex-col items-center justify-center py-6">
        <Icon404 className="mx-auto aspect-square w-[300px] max-w-[80vw] md:w-[500px]" />
        <div className="space-x-2 pt-8 md:space-y-5 md:pt-12 xl:pt-16">
          <div className="max-w-md text-center">
            <p className="mb-4 text-xl font-bold leading-normal md:text-2xl">
              {t('common.notFound.title')}
              <Twemoji emoji={'face-with-monocle'} />
            </p>
            <p className="mb-8">{t('common.notFound.description')}</p>
            <Link href="/">
              <Button>{t('common.notFound.backToHome')}</Button>
            </Link>
          </div>
        </div>
      </div>
    </Container>
  )
}
